var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-grid" },
    [
      _c("ag-grid-vue", {
        staticClass: "ag-theme-custom",
        staticStyle: { width: "100%", height: "100%" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          loading: _vm.loading,
          "default-col-def": _vm.defaultColDef,
          "auto-group-column-def": _vm.autoGroupColumnDef,
          "group-default-expanded": 3,
          "row-data": _vm.loading ? null : _vm.processedReportingAggregations,
        },
        on: {
          "grid-ready": _vm.onGridReady,
          "first-data-rendered": _vm.onFirstDataRendered,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }